/*
 * Gift With Purchase (GWP) Cart Functionality
 * Automatically adds/removes free gift based on cart threshold
 * Supports multiple thresholds
 */

(function() {
  // GWP settings are passed from theme.liquid via window.gwpSettings
  if (!window.gwpSettings || !window.gwpSettings.enabled || !window.gwpSettings.thresholds || window.gwpSettings.thresholds.length === 0) {
    return;
  }

  var gwpSettings = window.gwpSettings;
  var thresholds = gwpSettings.thresholds;

  // Sort thresholds by amount (lowest first)
  thresholds.sort(function(a, b) {
    return a.threshold - b.threshold;
  });

  // Helper function to call CartItems.loadHTML() after GWP operations
  function callCartLoadHTML(cart) {
    // First ensure cart data is updated via theme:cart:change
    document.dispatchEvent(new CustomEvent('theme:cart:change', {
      detail: { cart: cart },
      bubbles: true
    }));
    
    // Then trigger reload which calls loadHTML()
    // Add a small delay to ensure cart:change is processed first
    setTimeout(function() {
      document.dispatchEvent(new CustomEvent('theme:cart:reload', {bubbles: true}));
    }, 50);
  }

  window.loadCartHTML = function() {
    window.fetch(`${window.theme.routes.root_url}?section_id=header`)
      .then(function(response) {
        if (!response.ok) {
          throw {status: response.statusText};
        }
        return response.text();
      })
      .then(function(htmlText) {
        // Parse the HTML string into a DOM document
        let parser = new DOMParser();
        let doc = parser.parseFromString(htmlText, 'text/html');
        // Find the GWP message in the fetched HTML
        let cartMessageGwpResponse = doc.querySelector('.cart__message--gwp');
        // Find the GWP message in the current page
        let cartMessageGwp = document.querySelector('.cart__message--gwp');

        if(cartMessageGwpResponse && cartMessageGwp && cartMessageGwp.classList.contains('cart--hidden')){
          cartMessageGwp.classList.remove('cart--hidden');
        }
        
        if (cartMessageGwp && cartMessageGwpResponse) {
          cartMessageGwp.innerHTML = cartMessageGwpResponse.innerHTML;
        } else if (cartMessageGwpResponse && !cartMessageGwp) {
          // Clone the element from the fetched HTML
          let gwpElement = cartMessageGwpResponse.cloneNode(true);
          let drawerBodyErrors = document.querySelector('.drawer__body .errors');
          
          if (drawerBodyErrors && drawerBodyErrors.parentNode) {
            // Insert the GWP message before the errors element
            drawerBodyErrors.parentNode.insertBefore(gwpElement, drawerBodyErrors);
          } else {
            // Try to find the drawer body or cart container
            let drawerBody = document.querySelector('.drawer__body');
            if (drawerBody) {
              // Insert at the beginning of drawer body, or before first child if exists
              if (drawerBody.firstChild) {
                drawerBody.insertBefore(gwpElement, drawerBody.firstChild);
              } else {
                drawerBody.appendChild(gwpElement);
              }
            }
          }
        } else if (cartMessageGwp && !cartMessageGwpResponse) {
          cartMessageGwp.classList.add('cart--hidden');
        }

      })
      .catch(function(error) {
        console.error('Error loading cart HTML:', error);
      });
  }

  function checkAndUpdateGWP(cart) {
    if (!gwpSettings.enabled || thresholds.length === 0 || isUpdatingGWP) {
      return;
    }
    // Set flag to prevent recursive calls
    isUpdatingGWP = true;

    var cartTotal = cart.total_price / 100;
    var hasGift = false;
    var giftLineItems = [];
    var giftProductIds = [];

    // Collect all gift product IDs
    thresholds.forEach(function(threshold) {
      giftProductIds.push(threshold.productId);
    });

    // Check if any gift is already in cart and calculate total excluding gifts
    var cartTotalExcludingGift = cartTotal;
    for (var i = 0; i < cart.items.length; i++) {
      if (giftProductIds.indexOf(cart.items[i].product_id) !== -1) {
        hasGift = true;
        giftLineItems.push(cart.items[i]);
        // final_line_price is in cents, so divide by 100 to get dollars
        cartTotalExcludingGift = cartTotalExcludingGift - (cart.items[i].final_line_price / 100);
      }
    }

    // Determine which thresholds the cart qualifies for (all qualifying thresholds)
    var qualifiedThresholds = [];
    for (var j = 0; j < thresholds.length; j++) {
      if (cartTotalExcludingGift >= thresholds[j].threshold) {
        qualifiedThresholds.push(thresholds[j]);
      }
    }

    // Determine which gifts should be in cart
    var expectedGiftProductIds = qualifiedThresholds.map(function(threshold) {
      return threshold.productId;
    });
    
    // Find which threshold products are currently in cart
    var currentGiftProductIds = [];
    if (giftLineItems.length > 0) {
      giftLineItems.forEach(function(giftItem) {
        currentGiftProductIds.push(giftItem.product_id);
      });
    }

    // Update GWP message
    // Track if any async operations are being performed
    var hasAsyncOperations = false;
    
    // Add, remove, or update gifts based on thresholds
    if (qualifiedThresholds.length > 0) {
      // Should have gifts - add all qualifying gifts that aren't already in cart
      qualifiedThresholds.forEach(function(threshold) {
        if (currentGiftProductIds.indexOf(threshold.productId) === -1) {
          // Gift not in cart, add it
          hasAsyncOperations = true;
          addGiftToCart(threshold);
        }
      });
      
      // Remove gifts that no longer qualify
      if (hasGift && giftLineItems.length > 0) {
        giftLineItems.forEach(function(giftItem) {
          if (expectedGiftProductIds.indexOf(giftItem.product_id) === -1) {
            // Gift is in cart but no longer qualifies, remove it
            hasAsyncOperations = true;
            removeGiftFromCart(giftItem.product_id);
          }
        });
      }
    } else {
      // Should not have any gifts
      if (hasGift && giftLineItems.length > 0) {
        // Remove all gifts from cart
        giftLineItems.forEach(function(giftItem) {
          hasAsyncOperations = true;
          removeGiftFromCart(giftItem.product_id);
        });
      }
    }
    
    // Only reset flag if no async operations were started
    // Otherwise, the flag will be reset when async operations complete
    if (!hasAsyncOperations) {
      isUpdatingGWP = false;
    }
  }

  function addGiftToCart(threshold) {
    if (!threshold || !threshold.variantId) {
      return;
    }

    var formData = new URLSearchParams();
    formData.append('id', threshold.variantId);
    formData.append('quantity', 1);
    formData.append('properties[_gwp]', 'true');
    formData.append('properties[_gwp_threshold]', threshold.threshold); // Mark as GWP

    fetch(window.theme.routes.cart + '/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData.toString()
    })
    .then(function(response) {
      return response.json();
    })
    .then(function(data) {
      // Fetch the updated cart to get the latest state
      return fetch(window.theme.routes.cart + '.js')
        .then(function(response) {
          return response.json();
        });
    })
    .then(function(cart) {
      // Reset the flag before dispatching events
      isUpdatingGWP = false;
      
      // Call CartItems.loadHTML() to update the cart UI
      callCartLoadHTML(cart);
      window.loadCartHTML();
    })
    .catch(function(error) {
      console.error('Error adding GWP gift:', error);
      isUpdatingGWP = false;
    });
  }

  function removeGiftFromCart(productId, callback) {
    fetch(window.theme.routes.cart + '.js')
      .then(function(response) {
        return response.json();
      })
      .then(function(cart) {
        // Find and remove gift line item
        var updates = {};
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].product_id === productId) {
            updates[cart.items[i].key] = 0;
            break;
          }
        }
        
        if (Object.keys(updates).length > 0) {
          return fetch(window.theme.routes.cart + '/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ updates: updates })
          })
          .then(function(response) {
            return response.json();
          });
        }
        return null;
      })
      .then(function(updatedCart) {
        if (updatedCart) {
          // Reset the flag before dispatching events
          isUpdatingGWP = false;
          
          // Call CartItems.loadHTML() to update the cart UI
          callCartLoadHTML(updatedCart);
          window.loadCartHTML();
        } else {
          isUpdatingGWP = false;
        }
        
        if (callback) {
          callback();
        }
      })
      .catch(function(error) {
        console.error('Error removing GWP gift:', error);
        isUpdatingGWP = false;
        if (callback) {
          callback();
        }
      });
  }

  // Flag to prevent infinite loops when adding/removing gifts
  var isUpdatingGWP = false;

  // Listen for cart changes
  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart && !isUpdatingGWP) {
      // Add a small delay to ensure cart is fully updated
      setTimeout(function() {
        // Fetch fresh cart data to ensure we have the latest state
        fetch(window.theme.routes.cart + '.js')
          .then(function(response) {
            return response.json();
          })
          .then(function(freshCart) {
            if (freshCart) {
              checkAndUpdateGWP(freshCart);
            }
          })
          .catch(function(error) {
            console.error('Error fetching cart for GWP update:', error);
            // Fallback to using the cart from the event
            checkAndUpdateGWP(cart);
          });
      }, 100);
    }
  });

  // Listen for cart reload - update message after HTML is reloaded
  document.addEventListener('theme:cart:reload', function() {
    // Wait for cart HTML to reload, then fetch cart and update message
    setTimeout(function() {
      fetch(window.theme.routes.cart + '.js')
        .then(function(response) {
          return response.json();
        })
        .then(function(cart) {
        })
        .catch(function(error) {
          console.error('Error loading cart for GWP message update:', error);
        });
    }, 300);
  });

  // Check on initial cart load
  document.addEventListener('theme:cart:init', function(event) {
    fetch(window.theme.routes.cart + '.js')
      .then(function(response) {
        return response.json();
      })
      .then(function(cart) {
        checkAndUpdateGWP(cart);
      })
      .catch(function(error) {
        console.error('Error loading cart for GWP:', error);
      });
  });
})();

